import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { st, classes } from './Options.st.css';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
var Options = function (_a) {
    var clickHandler = _a.clickHandler, className = _a.className;
    var t = useTranslation()[0];
    var keyUpHandler = function (e) {
        if (e.key === 'Enter') {
            clickHandler(true);
        }
    };
    var ua = navigator.userAgent.toLowerCase();
    var isSafari = ua.indexOf('safari') !== -1 && ua.indexOf('chrome') <= -1;
    return (React.createElement("button", { "aria-label": t('Google_Calendar_MoreActions'), role: 'button', onKeyUp: keyUpHandler, onClick: function (e) { return e.detail === 1 && clickHandler(); }, className: st(classes.root, { isSafari: isSafari }, className) },
        React.createElement(MoreVertSharpIcon, null)));
};
export default Options;
//# sourceMappingURL=Options.js.map